<template>
  <div>
    <div>
      <el-upload
        class="upload-demo"
        ref="uploadBtn"
        action
        multiple
        :on-change="handleChange"
        :show-file-list="false"
        :http-request="uploadSectionFile"
        :before-upload="beforeUpload"
      >
        <slot></slot>
      </el-upload>
    </div>
  </div>
</template>

<script>
import { receivableApi } from "@/common/api/receivableApi";
export default {
  props:{
    uploadFun:Function
  },
  data() {
    return {
      fileList: [],
      fileNum: 0,
      postFile: []
    };
  },
  beforeMount() {},
  mounted() {},

  methods: {
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    beforeUpload() {
    },
    clearFiles() {
      this.$refs["uploadBtn"].clearFiles();
      this.fileNum = 0;
      this.fileList = [];
    },
    uploadSectionFile(params) {
      var option = {
        bulkInvoiceDocumentFiles: params.file
      };
      if(this.uploadFun){
        this.uploadFun(params.file)
        return
      }
     
      receivableApi
        .uploadDocuments(option)
        .then(res => {
          this.clearFiles();
        })
        .catch(err => {
          console.log("err", err);
          this.toast(err);
          this.clearFiles();
        });
    },
  },

  computed: {}
};
</script>
